export type User = {
  id: string;
  username: string;
  displayName: string;
};

export type Note = {
  id: string;
  title: string;
  content: string;
  isPinned: boolean;
  isArchived: boolean;
  createdAt: number;
  updatedAt: number;
};

export class ApiError extends Error {
  status: number;

  constructor(message: string, status: number) {
    super(message);
    this.status = status;
  }
}

async function request<T>(path: string, options?: RequestInit): Promise<T> {
  const response = await fetch(path, {
    ...options,
    credentials: 'same-origin',
    headers: {
      ...(options?.body ? { 'Content-Type': 'application/json' } : {}),
      ...options?.headers,
    },
  });
  const body = (await response.json().catch(() => ({}))) as T & { error?: string };
  if (!response.ok) {
    throw new ApiError(body.error || '请求失败，请稍后重试', response.status);
  }
  return body;
}

export const api = {
  auth: {
    me: () => request<{ user: User }>('/api/auth/me'),
    login: (data: { account: string; password: string; remember: boolean }) =>
      request<{ user: User }>('/api/auth/login', {
        method: 'POST',
        body: JSON.stringify(data),
      }),
    logout: () => request<{ ok: true }>('/api/auth/logout', { method: 'POST' }),
  },
  notes: {
    list: (archived: boolean) =>
      request<{ notes: Note[] }>(`/api/notes?archived=${archived}`),
    create: () =>
      request<{ note: Note }>('/api/notes', {
        method: 'POST',
        body: JSON.stringify({ title: '', content: '' }),
      }),
    update: (id: string, data: Partial<Pick<Note, 'title' | 'content' | 'isPinned' | 'isArchived'>>) =>
      request<{ note: Note }>(`/api/notes/${id}`, {
        method: 'PATCH',
        body: JSON.stringify(data),
      }),
    remove: (id: string) =>
      request<{ ok: true }>(`/api/notes/${id}`, { method: 'DELETE' }),
  },
};
